export default __webpack_public_path__ + "static/media/inspection-icon.292a421d.svg";